// extracted by mini-css-extract-plugin
module.exports = {"lia-info-btn":"InfoPopover_lia-info-btn__Kn7ne","lia-with-label":"InfoPopover_lia-with-label__hzqCK","lia-label":"InfoPopover_lia-label__Y2Upw"};